import { ChevronLeft } from 'lucide-react';
import { useOnboarding } from './OnboardingContext';

// First real application step for each flow — cannot go back beyond these
const FIRST_REAL_STEPS = new Set([
  'phone',                    // Individual: first step
  'corporate-company-search', // Corporate: first step
]);

export function BackButton() {
  const { goToPreviousStep, currentStep, setCurrentStep } = useOnboarding();

  // Hide on welcome, success screens, AND the very first real step of each flow
  if (
    currentStep === 'welcome' ||
    currentStep === 'success' ||
    currentStep === 'corporate-success' ||
    FIRST_REAL_STEPS.has(currentStep)
  ) {
    return null;
  }

  const handleBack = () => {
    // From account-type, go back to welcome page
    if (currentStep === 'account-type') {
      setCurrentStep('welcome');
      return;
    }
    goToPreviousStep();
  };

  return (
    <button
      onClick={handleBack}
      className="absolute top-3 left-3 p-3 rounded-full hover:bg-secondary active:bg-secondary/80 transition-colors touch-manipulation z-10"
      aria-label="Go back"
      style={{ minWidth: '44px', minHeight: '44px' }}
    >
      <ChevronLeft className="w-6 h-6 text-foreground" />
    </button>
  );
}
